import { useState, useEffect } from 'react';
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import * as Icon from 'react-bootstrap-icons';
import Select, { components } from "react-select";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function Shiftassign() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("staffid");
    const accessroleid = localStorage.getItem("roleid");
    // console.log("gghfhg" + accessroleid);
    const Swal = require('sweetalert2')

    const [branch, setBranch] = useState([]);
    const [branchId, setBranchId] = useState("");
    // const [Branchin, setBranchin] = useState("");
    const [selectedBranchName, setSelectedBranchName] = useState("");
    const [employees, setEmployees] = useState([]);

    const [showAssignPanel, setShowAssignPanel] = useState(false);
    const [activeTab, setActiveTab] = useState("daily");
    const [isApplicableWeek, setIsApplicableWeek] = useState(false);

    const [shifttype, setshifttype] = useState([]);
    const [shiftTypeId, setShiftTypeId] = useState("");
    const [dept, setDept] = useState([]);
    const [deptId, setDeptId] = useState(null);
    const [staff, setStaff] = useState([]);
    const [effectiveDate, setEffectiveDate] = useState("");
    const [shiftAssignments, setShiftAssignments] = useState([]);
    // Inter Shift
    const [interDeptId, setInterDeptId] = useState("");
    const [interStaff, setInterStaff] = useState([]);
    const [interStaffId, setInterStaffId] = useState("");
    const [interBranchId, setInterBranchId] = useState("");
    const [interShiftTypeId, setInterShiftTypeId] = useState("");
    // const [interEffectiveDate, setInterEffectiveDate] = useState("");
    const [isInterApplicableWeek, setIsInterApplicableWeek] = useState(false);
    const [interShiftAssignments, setInterShiftAssignments] = useState([]);
    const [interStaffIds, setInterStaffIds] = useState([]);
    //Intra Shift
    const [intraDeptId, setIntraDeptId] = useState("");
    const [intraStaffId, setIntraStaffId] = useState("");
    const [intraStaff, setIntraStaff] = useState([]);
    const [intraShiftTypeId, setintraShiftTypeId] = useState("");
    // const [intraEffectiveDate, setIntraEffectiveDate] = useState("");
    const [isIntraApplicableWeek, setIsIntraApplicableWeek] = useState(false);
    const [intraShiftAssignments, setIntraShiftAssignments] = useState([]);

    const [staffids, setStaffids] = useState([]);
    const [intraStaffIds, setIntraStaffIds] = useState([]);

    const [isSuperAdmin, setIsSuperAdmin] = useState("");
    const [branches, setBranches] = useState([]);
    // const [interBranches, setInterBranches] = useState([]);

    const [inbranches, setinbranches] = useState("");
    const [interBranchnew, setInterBranchnew] = useState([]);
    //Daily shift

    const selectedDept = dept?.find(
        (item) => String(item?.dept_id) === String(deptId)
    );
    const selectedShift = shifttype.find(
        (item) => item.type_id.toString() === shiftTypeId.toString()
    );

    const selectedBranch = branchId
        ? branch.find(
            (item) =>
                String(item?.branch_id) === String(branchId)
        )
        : null;

    // const staffOptions = staff.map((item) => ({
    //     value: item.staff_id,
    //     label: item.staff_name,
    //     staff_code: item.staff_code,
    //     staff_name: item.staff_name,
    // }));

    // console.log("Staff Options:", staffOptions);
    //Inter Shift
    const selectedInterStaff = interStaff.find(
        (item) => item.staff_id.toString() === interStaffId.toString()
    );

    const selectedInterDept = dept.find(
        (item) => item.dept_id.toString() === interDeptId.toString()
    );

    const selectedInterBranch = branch.find(
        (item) =>
            String(item?.branch_id || "") ===
            String(branchId || "")
    );

    const selectedShiftBranch = interBranchId
        ? branch.find(
            (item) =>
                String(item?.branch_id) === String(interBranchId)
        )
        : null;

    const selectedInterShift = shifttype.find(
        (item) =>
            String(item.type_id) === String(interShiftTypeId)
    );
    //Intra Shift
    const selectedIntraStaff = intraStaff.find(
        (item) =>
            item.staff_id.toString() === intraStaffId.toString()
    );

    const selectedIntraDept = dept.find(
        (item) =>
            item.dept_id.toString() === intraDeptId.toString()
    );

    const selectedIntraBranch = branch.find(
        (item) =>
            String(item?.branch_id || "") ===
            String(branchId || "")
    );

    const selectedIntraShift = shifttype.find(
        (item) =>
            item.type_id.toString() === intraShiftTypeId.toString()
    );

    //disable previous dates in date picker
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const minDate = tomorrow.toISOString().split("T")[0];


    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const [interDateRange, setInterDateRange] = useState([null, null]);
    const [interFromDate, interToDate] = interDateRange;
    const [intraDateRange, setIntraDateRange] = useState([null, null]);
    const [intraFromDate, intraToDate] = intraDateRange;
    const isContinuousShift = (shiftInfo) => {
        return !shiftInfo.assign_todate;
    };
    // Fetch branch name for dropdown

    useEffect(() => {

        const fetchData = async () => {

            try {

                // Get logged-in staff details
                const staffRes = await axios.get(
                    `${baseurladdress}getstaffdetails/${accessuserid}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                const loginStaff = staffRes.data.response;

                const loginBranchId = Number(loginStaff.staff_placedat);
                const loginBranchName = loginStaff.branch_name;
                const loginRoleId = Number(loginStaff.staff_role);

                //  console.log("Login Staff:", loginStaff);

                // =========================
                // SUPER ADMINISTRATOR
                // =========================

                if (loginRoleId === 71) {

                    setIsSuperAdmin(true);

                    const branchRes = await axios.get(
                        `${baseurladdress}getallbranchs`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );

                    setBranch(branchRes.data.response || []);
                }

                // =========================
                // NORMAL USER
                // =========================

                else {

                    setIsSuperAdmin(false);

                    setBranchId(loginBranchId);
                    setSelectedBranchName(loginBranchName);

                    // Get all branches
                    const branchRes = await axios.get(
                        `${baseurladdress}getallbranchs`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );

                    const allBranches =
                        branchRes.data.response || [];

                    // Get assigned branch IDs
                    const userBranchIds =
                        loginStaff.user_branches
                            ? loginStaff.user_branches
                                .split(",")
                                .map(id => Number(id))
                            : [];

                    // console.log(
                    //     "Assigned Branch IDs:",
                    //     userBranchIds
                    // );

                    // Always include login branch
                    if (
                        !userBranchIds.includes(
                            loginBranchId
                        )
                    ) {
                        userBranchIds.push(
                            loginBranchId
                        );
                    }

                    // Filter branches
                    const filteredBranches =
                        allBranches.filter(branch =>
                            userBranchIds.includes(
                                Number(branch.branch_id)
                            )
                        );

                    // console.log(
                    //     "Filtered Branches:",
                    //     filteredBranches
                    // );

                    setBranch(filteredBranches);

                    // Load employees of login branch
                    fetchEmployees(loginBranchId);
                }

                // =========================
                // OTHER DROPDOWNS
                // =========================

                const [shiftRes, deptRes] =
                    await Promise.all([

                        axios.get(
                            `${baseurladdress}getallshifttype`,
                            {
                                headers: {
                                    Authorization: `Bearer ${accesstoken}`,
                                },
                            }
                        ),

                        axios.get(
                            `${baseurladdress}getalldepts`,
                            {
                                headers: {
                                    Authorization: `Bearer ${accesstoken}`,
                                },
                            }
                        )
                    ]);

                setshifttype(
                    shiftRes.data.response || []
                );

                setDept(
                    deptRes.data.response || []
                );

            } catch (error) {

                console.log(error);
            }
        };

        fetchData();

    }, []);
    const fetchEmployees = async (branchId) => {

        try {

            const response = await axios.get(
                `${baseurladdress}getstaffbybranch/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            setStaff(response.data.response || []);

        } catch (error) {

            console.log(error);

        }

    };
    //Search staff by branch and department for shift assignment
    useEffect(() => {
        const fetchStaff = async () => {
            try {
                // Branch + Department
                if (branchId && deptId) {

                    const response = await axios.get(
                        `${baseurladdress}staffbybranchanddept`,
                        {
                            params: {
                                branchId,
                                deptId
                            },
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    setStaff(response.data.response || []);
                }

                // Branch only
                else if (branchId) {
                    await getStaffByBranch(branchId);
                }
                else {
                    setStaff([]);
                }

            } catch (error) {

                console.log(error);
                setStaff([]);
            }
        };

        fetchStaff();

    }, [branchId, deptId]);

    // Search staff by branch and department for inter shift assignment
    useEffect(() => {
        const fetchInterStaff = async () => {
            try {
                // Branch + Department
                if (branchId && interDeptId) {
                    const response = await axios.get(
                        `${baseurladdress}staffbybranchanddept`,
                        {
                            params: {
                                branchId,
                                deptId: interDeptId
                            },
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    setInterStaff(response.data.response || []);
                }

                // Branch only
                else if (branchId) {

                    const response = await axios.get(
                        `${baseurladdress}getStaffByBranch/${branchId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    setInterStaff(response.data.response || []);
                }

                // Nothing selected
                else {

                    setInterStaff([]);
                }

            } catch (error) {

                console.log(error);
                setInterStaff([]);
            }
        };

        fetchInterStaff();

    }, [branchId, interDeptId]);

    useEffect(() => {

        const fetchIntraStaff = async () => {

            try {

                // Branch + Department
                if (branchId && intraDeptId) {

                    const response = await axios.get(
                        `${baseurladdress}staffbybranchanddept`,
                        {
                            params: {
                                branchId,
                                deptId: intraDeptId
                            },
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    setIntraStaff(response.data.response || []);
                }

                // Branch only
                else if (branchId) {

                    const response = await axios.get(
                        `${baseurladdress}getStaffByBranch/${branchId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    setIntraStaff(response.data.response || []);
                }

                // Nothing selected
                else {

                    setIntraStaff([]);
                }

            } catch (error) {

                console.log(error);
                setIntraStaff([]);
            }
        };

        fetchIntraStaff();

    }, [branchId, intraDeptId]);

    // Selecting the branch will fetch the employees working in that branch and display in the calendar
    useEffect(() => {

        if (!branchId) {
            setEmployees([]);
            setShiftAssignments([]);
            return;
        }

        const fetchData = async () => {

            try {

                const [staffRes, shiftRes] = await Promise.all([

                    axios.get(
                        `${baseurladdress}staffbybranch/${branchId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    ),

                    axios.get(
                        `${baseurladdress}getshiftassignments/${branchId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    )
                ]);

                setEmployees(staffRes.data.response || []);
                setShiftAssignments(shiftRes.data.response || []);

            } catch (error) {

                console.log(error);

                setEmployees([]);
                setShiftAssignments([]);
            }
        };

        fetchData();

    }, [branchId]);

    const getShiftAssignments = async () => {

        const response = await axios.get(
            `${baseurladdress}getshiftassignments/${branchId}`,
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        );

        setShiftAssignments(response.data.response || []);
    };
    //Selecting the branch will fetch the inter shift assignments for that branch and display in the calendar for intra shift
    const getInterShiftAssignments = async () => {
        try {

            const response = await axios.get(
                `${baseurladdress}getInterShiftAssignments/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.status === "success") {

                console.log(
                    "Inter Shift Data",
                    response.data.response
                );

                setInterShiftAssignments(
                    response.data.response
                );
            }

        } catch (error) {

            console.log(error);

            setInterShiftAssignments([]);
        }
    };

    //Selecting the branch will fetch the intra shift assignments for that branch and display in the calendar for intra shift
    const getIntraShiftAssignments = async () => {

        try {

            const response = await axios.get(
                `${baseurladdress}getIntraShiftAssignments/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.status === "success") {

                setIntraShiftAssignments(
                    response.data.response || []
                );

            }

        } catch (error) {

            console.log(error);

            setIntraShiftAssignments([]);

        }
    };

    useEffect(() => {
        if (!branchId) return;
        getShiftAssignments();
        getInterShiftAssignments();
        getIntraShiftAssignments();

    }, [branchId]);
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const res = await axios.get(
                    `${baseurladdress}getbranch`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                // IMPORTANT: make sure response is array
                setinbranches(res.data.response || []);

            } catch (error) {
                console.log("Error fetching branches:", error);
                setinbranches([]);
            }
        };

        fetchBranches();
    }, []);
    //Add daily shift
    const saveShiftAssignment = async () => {
        try {
            if (staffids.length === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: "Please select at least one employee",
                });
                return;
            }

            // Local date formatter (avoids timezone issues)
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");

                return `${year}-${month}-${day}`;
            };

            const fromDate = startDate
                ? formatDate(startDate)
                : null;

            let toDate = endDate
                ? formatDate(endDate)
                : fromDate;

            // If Applicable to 1 Week is checked
            if (isApplicableWeek && startDate) {
                const weekDate = new Date(startDate);
                weekDate.setDate(weekDate.getDate() + 6);

                toDate = formatDate(weekDate);
            }

            for (const selected of staffids) {
                const selectedStaff = staff.find(
                    (item) =>
                        item.staff_id.toString() ===
                        selected.value.toString()
                );

                const data = {
                    assign_staffid: selected.value,
                    assign_staffcode: selected.staff_code,
                    assign_staffname: selected.label.split(" (")[0],

                    assign_deptid: selectedDept?.dept_id,
                    assign_deptname: selectedDept?.dept_name,
                    assign_deptcode: selectedDept?.dept_code,

                    assign_branchid: selectedBranch?.branch_id,
                    assign_branchname: selectedBranch?.branch_name,

                    assign_shifttypeid: selectedShift?.type_id,
                    asign_shiftname: selectedShift?.type_name,

                    assing_fromdate: fromDate,
                    assign_todate: toDate,
                    assign_updby: accessuserid,
                };

                console.log("Selected Staff:", selected);
                console.log("Staff Code:", selectedStaff?.staff_code);
                console.log("From Date:", fromDate);
                console.log("To Date:", toDate);

                const response = await axios.post(
                    `${baseurladdress}adddailyshift`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error("Insert failed");
                }
            }

            await getShiftAssignments();

            // Reset form
            setDeptId("");
            setStaffids([]);
            setShiftTypeId("");
            setEffectiveDate("");
            setDateRange([null, null]);
            setIsApplicableWeek(false);
            setStaff([]);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Shift Assigned Successfully",
            });
        } catch (error) {
            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to save shift assignment",
            });
        } finally {
            console.log("Shift assignment process completed");
        }
    };

    const formatDate = (date) => {
        if (!date) return null;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };
    // Add inter shift

    const saveInterAssignment = async () => {
        try {

            if (interStaffIds.length === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: "Please select at least one employee"
                });
                return;
            }

            const shiftFromDate = interFromDate
                ? formatDate(interFromDate)
                : null;

            // If second date is not selected,
            // use first date as To Date
            let shiftToDate = interToDate
                ? formatDate(interToDate)
                : shiftFromDate;

            // If Applicable Week is checked,
            // override To Date = From Date + 6 days
            if (isInterApplicableWeek && interFromDate) {
                const weekDate = new Date(interFromDate);
                weekDate.setDate(weekDate.getDate() + 6);

                shiftToDate = formatDate(weekDate);
            }
            for (const selected of interStaffIds) {

                const data = {

                    staff_id: selected.value,
                    staff_name: selected.staff_name,

                    dept_id: selectedInterDept?.dept_id,
                    dept_name: selectedInterDept?.dept_name,

                    branch_id: selectedInterBranch?.branch_id,
                    branch_name: selectedInterBranch?.branch_name,

                    // shiftbranch_id: selectedShiftBranch?.branch_id,
                    // shiftbranch_name: selectedShiftBranch?.branch_name,
                    shiftbranch_id: interBranchnew?.value,
                    shiftbranch_name: interBranchnew?.label,

                    shifttype_id: selectedInterShift?.type_id,
                    shifttype_name: selectedInterShift?.type_name,

                    shiftmode: "1",
                    shift_from: shiftFromDate,
                    shift_to: shiftToDate,
                    // shift_from: interEffectiveDate,

                    // shift_to:
                    //     shiftToDate ||
                    //     interEffectiveDate,

                    crtd_by: accessuserid,
                };

                const response = await axios.post(
                    `${baseurladdress}addInterAssignment`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error("Insert failed");
                }
            }

            await getInterShiftAssignments();

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Inter Shift Assigned Successfully",
            });

            setInterDeptId("");
            setInterStaffIds([]);
            setInterBranchId("");
            setInterShiftTypeId("");
            //setInterEffectiveDate("");
            setInterDateRange([null, null]);


            setInterBranchnew(null);
            setIsInterApplicableWeek(false);
            // setInterStaff([]);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to Save Inter Shift",
            });
        }
    };
    // Add intra shift
    const saveIntraAssignment = async () => {

        try {

            if (intraStaffIds.length === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: "Please select at least one employee"
                });
                return;
            }


            const shiftFromDate = intraFromDate
                ? formatDate(intraFromDate)
                : null;

            // If second date is not selected,
            // use first date as To Date
            let shiftToDate = intraToDate
                ? formatDate(intraToDate)
                : shiftFromDate;

            // If Applicable Week is checked,
            // override To Date = From Date + 6 days
            if (isIntraApplicableWeek && intraFromDate) {
                const weekDate = new Date(intraFromDate);
                weekDate.setDate(weekDate.getDate() + 6);

                shiftToDate = formatDate(weekDate);
            }
            for (const selected of intraStaffIds) {

                const data = {

                    staff_id: selected.value,
                    staff_name: selected.staff_name,

                    dept_id: selectedIntraDept?.dept_id,
                    dept_name: selectedIntraDept?.dept_name,

                    branch_id: selectedIntraBranch?.branch_id,
                    branch_name: selectedIntraBranch?.branch_name,

                    shiftbranch_id: selectedIntraBranch?.branch_id,
                    shiftbranch_name: selectedIntraBranch?.branch_name,

                    shifttype_id: selectedIntraShift?.type_id,
                    shifttype_name: selectedIntraShift?.type_name,

                    shiftmode: "2",

                    // shift_from: intraEffectiveDate,

                    // shift_to:
                    //     shiftToDate ||
                    //     intraEffectiveDate,
                    shift_from: shiftFromDate,
                    shift_to: shiftToDate,
                    crtd_by: accessuserid
                };

                const response = await axios.post(
                    `${baseurladdress}addIntraAssignment`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error("Insert failed");
                }
            }

            await getIntraShiftAssignments();

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Intra Shift Assigned Successfully"
            });

            setIntraDeptId("");
            setIntraStaffIds([]);
            setintraShiftTypeId("");
            //setIntraEffectiveDate("");
            setIntraDateRange([null, null]);
            setIsIntraApplicableWeek(false);
            //   setIntraStaff([]);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to Save Intra Shift"
            });
        }
    };


    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const fromDate = startDate
        ? formatLocalDate(startDate)
        : null;

    let toDate = endDate
        ? formatLocalDate(endDate)
        : fromDate;

    if (isApplicableWeek && startDate) {
        const weekDate = new Date(startDate);
        weekDate.setDate(weekDate.getDate() + 6);

        toDate = formatLocalDate(weekDate);
    }
    //Calendar weeks
    const getCurrentWeekDates = () => {
        const today = new Date();
        const dates = [];

        for (let i = 0; i < 7; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);

            dates.push({
                day: date.getDate(),
                weekDay: date.toLocaleDateString("en-US", {
                    weekday: "short",
                }),
                fullDate: formatLocalDate(date),
            });
        }

        return dates;
    };
    const weekDates = getCurrentWeekDates();

    //dot displayed in the daily shift --- calendar
    const hasShiftAssignment = (staffId, date) => {
        return shiftAssignments.some((item) => {

            if (Number(item.assign_staffid) !== Number(staffId)) {
                return false;
            }

            const currentDate = new Date(date);
            currentDate.setHours(0, 0, 0, 0);

            const fromDate = new Date(item.assing_fromdate);
            fromDate.setHours(0, 0, 0, 0);

            let toDate;

            // If To Date is NULL, keep assignment active forever
            if (!item.assign_todate) {
                toDate = new Date("9999-12-31");
            } else {
                toDate = new Date(item.assign_todate);
            }

            toDate.setHours(23, 59, 59, 999);

            return currentDate >= fromDate && currentDate <= toDate;
        });
    };   // const hasShiftAssignment = (
    //     staffId,
    //     date
    // ) => {

    //     return shiftAssignments.some(
    //         (item) => {

    //             const fromDate =
    //                 new Date(
    //                     item.assing_fromdate
    //                 );

    //             const toDate =
    //                 new Date(
    //                     item.assign_todate
    //                 );

    //             const currentDate =
    //                 new Date(date);

    //             fromDate.setHours(
    //                 0, 0, 0, 0
    //             );

    //             toDate.setHours(
    //                 0, 0, 0, 0
    //             );

    //             currentDate.setHours(
    //                 0, 0, 0, 0
    //             );
    //             console.log(
    //                 "From:",
    //                 item.assing_fromdate,
    //                 "To:",
    //                 item.assign_todate,
    //                 "Current:",
    //                 date
    //             );
    //             return (
    //                 Number(
    //                     item.assign_staffid
    //                 ) === Number(staffId)
    //                 &&
    //                 currentDate >= fromDate
    //                 &&
    //                 currentDate <= toDate
    //             );
    //         }
    //     );
    // };

    //dot displayed in the inter shift --- calendar
    const hasInterShiftAssignment = (
        staffId,
        date
    ) => {

        return interShiftAssignments.some(
            (item) => {

                const fromDate =
                    new Date(
                        item.shift_from
                    );

                const toDate =
                    item.shift_to
                        ? new Date(
                            item.shift_to
                        )
                        : new Date(
                            item.shift_from
                        );

                const currentDate =
                    new Date(date);

                fromDate.setHours(
                    0, 0, 0, 0
                );

                toDate.setHours(
                    0, 0, 0, 0
                );

                currentDate.setHours(
                    0, 0, 0, 0
                );

                return (
                    Number(
                        item.staff_id
                    ) === Number(staffId)
                    &&
                    currentDate >= fromDate
                    &&
                    currentDate <= toDate
                );
            }
        );
    };

    // dot displayed in the intra shift --- calendar
    const hasIntraShiftAssignment = (
        staffId,
        date
    ) => {

        return intraShiftAssignments.some(
            (item) => {

                const fromDate =
                    new Date(item.shift_from);

                const toDate =
                    item.shift_to
                        ? new Date(item.shift_to)
                        : new Date(item.shift_from);

                const currentDate =
                    new Date(date);

                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(0, 0, 0, 0);
                currentDate.setHours(0, 0, 0, 0);

                return (
                    Number(item.staff_id) === Number(staffId)
                    &&
                    currentDate >= fromDate
                    &&
                    currentDate <= toDate
                );
            }
        );
    };
    // Get daily shift details for tooltip
    const getShiftDetails = (staffId, date) => {
        return shiftAssignments.find((item) => {

            if (Number(item.assign_staffid) !== Number(staffId)) {
                return false;
            }

            const currentDate = new Date(date);
            currentDate.setHours(0, 0, 0, 0);

            const fromDate = new Date(item.assing_fromdate);
            fromDate.setHours(0, 0, 0, 0);

            let toDate;

            if (!item.assign_todate) {
                toDate = new Date("9999-12-31");
            } else {
                toDate = new Date(item.assign_todate);
            }

            toDate.setHours(23, 59, 59, 999);

            return currentDate >= fromDate && currentDate <= toDate;
        });
    };
    // const getShiftDetails = (staffId, date) => {

    //     return shiftAssignments.find((item) => {

    //         const fromDate = new Date(item.assing_fromdate);
    //         const toDate = new Date(
    //             item.assign_todate || item.assing_fromdate
    //         );

    //         const currentDate = new Date(date);

    //         fromDate.setHours(0, 0, 0, 0);
    //         toDate.setHours(0, 0, 0, 0);
    //         currentDate.setHours(0, 0, 0, 0);

    //         return (
    //             Number(item.assign_staffid) === Number(staffId) &&
    //             currentDate >= fromDate &&
    //             currentDate <= toDate
    //         );
    //     });
    // };

    // Get inter shift details for tooltip
    const getInterShiftDetails = (
        staffId,
        date
    ) => {

        return interShiftAssignments.find(
            (item) => {

                const fromDate =
                    new Date(item.shift_from);

                const toDate =
                    item.shift_to
                        ? new Date(item.shift_to)
                        : new Date(item.shift_from);

                const currentDate =
                    new Date(date);

                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(0, 0, 0, 0);
                currentDate.setHours(0, 0, 0, 0);

                return (
                    Number(item.staff_id) === Number(staffId)
                    &&
                    currentDate >= fromDate
                    &&
                    currentDate <= toDate
                );
            }
        );
    };

    //Get intra shift details for tooltip
    const getIntraShiftDetails = (
        staffId,
        date
    ) => {

        return intraShiftAssignments.find(
            (item) => {

                const fromDate =
                    new Date(item.shift_from);

                const toDate =
                    item.shift_to
                        ? new Date(item.shift_to)
                        : new Date(item.shift_from);

                const currentDate =
                    new Date(date);

                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(0, 0, 0, 0);
                currentDate.setHours(0, 0, 0, 0);

                return (
                    Number(item.staff_id) === Number(staffId)
                    &&
                    currentDate >= fromDate
                    &&
                    currentDate <= toDate
                );
            }
        );
    };

    //Convert time to AM/PM Format
    const formatTime = (time) => {
        if (!time) return "";

        const [hours, minutes] = time.split(":");

        const date = new Date();
        date.setHours(hours, minutes);

        return date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };

    //Get staffname when select the branch name
    const getStaffByBranch = async (branchId) => {
        try {
            const response = await axios.get(
                `${baseurladdress}getStaffByBranch/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            console.log("API Response:", response.data.response);

            setStaff(
                response.data.response.map((item) => ({
                    staff_id: item.staff_id,
                    staff_name: item.staff_name,
                    staff_code: item.staff_code, // IMPORTANT
                }))
            );

        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        //  console.log("Updated Staff State:", staff);
    }, [staff]);
    // const getStaffByBranch = async (branchId) => {
    //     try {
    //         const response = await axios.get(
    //             `${baseurladdress}getStaffByBranch/${branchId}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`,
    //                 },
    //             }
    //         );

    //         if (response.data.status === "success") {
    //             console.log("Staff Response:", response.data.response);
    //             setStaff(response.data.response || []);
    //         } else {
    //             setStaff([]);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         setStaff([]);
    //     }
    // };
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await axios.get(
                    `${baseurladdress}getbranch`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                setBranches(response.data.response || []);
            } catch (error) {
                console.log(error);
            }
        };

        fetchBranches();
    }, [accesstoken]);



    // Check whether the shift is assigned to the staff in inter
    const handleDateRangeChange = async (update) => {

        // Clear selection
        if (!update || !update[0]) {
            setInterDateRange(update);
            return;
        }

        // Validate staff selection
        if (interStaffIds.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please select a staff first"
            });
            return;
        }

        try {

            // Check both start date and end date
            const datesToCheck = [];

            if (update[0]) {
                datesToCheck.push(formatDate(update[0]));
            }

            if (update[1]) {
                datesToCheck.push(formatDate(update[1]));
            }

            const assignedStaffs = [];

            for (const staff of interStaffIds) {

                for (const selectedDate of datesToCheck) {

                    const response = await axios.post(
                        `${baseurladdress}checkShiftAssigned`,
                        {
                            staff_id: staff.value,
                            shift_date: selectedDate
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    console.log(
                        "Checking:",
                        staff.label,
                        selectedDate,
                        response.data
                    );

                    if (response.data.status === "exists") {

                        assignedStaffs.push({
                            staffId: staff.value,
                            staffName: staff.label,
                            date: selectedDate,
                            assignmentId: response.data.data[0].id
                        });

                        break;
                    }
                }
            }

            // If any staff already have shifts
            if (assignedStaffs.length > 0) {

                const staffHtml = assignedStaffs
                    .map(
                        item => `
                        <div style="
                            padding:4px 0;
                            color:#198754;
                            font-weight:600;
                        ">
                            • ${item.staffName} already has a shift on ${item.date}
                        </div>
                    `
                    )
                    .join("");

                const result = await Swal.fire({
                    icon: "warning",
                    title: "Shift Already Assigned",
                    html: `
                    <div style="text-align:left;">
                        ${staffHtml}

                        <div style="
                            color:red;
                            font-weight:bold;
                            margin-top:15px;
                            font-size:16px;
                        ">
                            To proceed, the existing shift assignments must be removed.
                        </div>
                    </div>
                `,
                    showCancelButton: true,
                    confirmButtonText: "Proceed",
                    cancelButtonText: "No",
                    confirmButtonColor: "#d33"
                });

                if (!result.isConfirmed) {

                    setInterDateRange([null, null]);
                    return;
                }

                try {

                    for (const item of assignedStaffs) {

                        const deleteResponse = await axios.post(
                            `${baseurladdress}deleteShiftForDate`,
                            {
                                assignment_id: item.assignmentId,
                                selected_date: item.date
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accesstoken}`
                                }
                            }
                        );

                        if (deleteResponse.data.status !== "success") {

                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: deleteResponse.data.message
                            });

                            return;
                        }
                        console.log("Deleting Assignment:", item.assignmentId);

                        setInterShiftAssignments(prev => {
                            console.log("Current State:", prev);

                            return prev.filter(
                                shift =>
                                    Number(shift.id) !== Number(item.assignmentId)
                            );
                        });
                        // setInterShiftAssignments(prev =>
                        //     prev.filter(
                        //         shift =>
                        //             Number(shift.id) !== Number(item.assignmentId)
                        //     )
                        // );
                    }
                    console.log("Inter Assignments:", interShiftAssignments);
                    //console.log("Intra Assignments:", intraShiftAssignments);
                    await Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Existing shift assignments removed successfully."
                    });

                    setInterDateRange(update);

                } catch (error) {

                    console.error(error);

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Unable to remove existing shift assignments."
                    });

                    return;
                }

            } else {

                // No shift assigned
                setInterDateRange(update);
            }

        } catch (error) {

            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to validate shift assignment."
            });
        }
    };

    const handleIntraDateRangeChange = async (update) => {

        // Clear selection
        if (!update || !update[0]) {
            setIntraDateRange(update);
            return;
        }

        // Validate staff selection
        if (intraStaffIds.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please select a staff first"
            });
            return;
        }

        try {

            const datesToCheck = [];

            if (update[0]) {
                datesToCheck.push(formatDate(update[0]));
            }

            if (update[1]) {
                datesToCheck.push(formatDate(update[1]));
            }

            const assignedStaffs = [];

            for (const staff of intraStaffIds) {

                for (const selectedDate of datesToCheck) {

                    const response = await axios.post(
                        `${baseurladdress}checkShiftAssigned`,
                        {
                            staff_id: staff.value,
                            shift_date: selectedDate
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    if (response.data.status === "exists") {

                        assignedStaffs.push({
                            staffId: staff.value,
                            staffName: staff.label,
                            date: selectedDate,
                            assignmentId: response.data.data[0].id
                        });

                        break;
                    }
                }
            }

            if (assignedStaffs.length > 0) {

                const staffHtml = assignedStaffs
                    .map(
                        item => `
                        <div style="
                            padding:4px 0;
                            color:#198754;
                            font-weight:600;
                        ">
                            • ${item.staffName} already has a shift on ${item.date}
                        </div>
                    `
                    )
                    .join("");

                const result = await Swal.fire({
                    icon: "warning",
                    title: "Shift Already Assigned",
                    html: `
                    <div style="text-align:left;">
                        ${staffHtml}

                        <div style="
                            color:red;
                            font-weight:bold;
                            margin-top:15px;
                            font-size:16px;
                        ">
                            To proceed, the existing shift assignments must be removed.
                        </div>
                    </div>
                `,
                    showCancelButton: true,
                    confirmButtonText: "Proceed",
                    cancelButtonText: "No",
                    confirmButtonColor: "#d33"
                });

                if (!result.isConfirmed) {
                    setIntraDateRange([null, null]);
                    return;
                }

                for (const item of assignedStaffs) {

                    const deleteResponse = await axios.post(
                        `${baseurladdress}deleteShiftForDate`,
                        {
                            assignment_id: item.assignmentId,
                            selected_date: item.date
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`
                            }
                        }
                    );

                    if (deleteResponse.data.status !== "success") {
                        await getShiftAssignments();
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: deleteResponse.data.message
                        });

                        return;
                    }
                    // Remove deleted shift from state immediately
                    setIntraShiftAssignments(prev =>
                        prev.filter(
                            shift =>
                                Number(shift.id) !== Number(item.assignmentId)
                        )
                    );
                }
                await getShiftAssignments();

                await Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Existing shift assignments removed successfully."
                });

                setIntraDateRange(update);

            } else {

                setIntraDateRange(update);
            }

        } catch (error) {

            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to validate shift assignment."
            });
        }
    };
    const allOption = {
        value: "all",
        label: "All Staff"
    };

    const staffOptions = [
        allOption,
        ...staff.map(item => ({
            value: item.staff_id,
            label: `${item.staff_name} (${item.staff_code})`,
            staff_name: item.staff_name,
            staff_code: item.staff_code
        }))
    ];
    const Option = (props) => {
        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: "8px" }}
                />
                <label>{props.label}</label>
            </components.Option>
        );
    };
    const handleStaffChange = (selectedOptions) => {

        if (!selectedOptions) {
            setStaffids([]);
            return;
        }

        const isAllSelected = selectedOptions.some(
            option => option.value === "all"
        );

        if (isAllSelected) {
            setStaffids(
                staff.map(item => ({
                    value: item.staff_id,
                    label: `${item.staff_name} (${item.staff_code})`,
                    staff_name: item.staff_name,
                    staff_code: item.staff_code
                }))
            );
        } else {
            setStaffids(selectedOptions);
        }
    };
    const interAllOption = {
        value: "all",
        label: "All Staff"
    };

    const interStaffOptions = [
        interAllOption,
        ...interStaff.map(item => ({
            value: item.staff_id,
            label: `${item.staff_name} (${item.staff_code})`,
            staff_name: item.staff_name,
            staff_code: item.staff_code
        }))
    ];
    const CheckboxOption = (props) => (
        <components.Option {...props}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
                style={{ marginRight: "8px" }}
            />
            <label>{props.label}</label>
        </components.Option>
    );
    const handleInterStaffChange = (selectedOptions) => {

        if (!selectedOptions) {
            setInterStaffIds([]);
            return;
        }

        const isAllSelected = selectedOptions.some(
            option => option.value === "all"
        );

        if (isAllSelected) {

            const allStaff = interStaff.map(item => ({
                value: item.staff_id,
                label: `${item.staff_name} (${item.staff_code})`,
                staff_name: item.staff_name,
                staff_code: item.staff_code
            }));

            setInterStaffIds(allStaff);

        } else {
            setInterStaffIds(selectedOptions);
        }
    };
    const intraAllOption = {
        value: "all",
        label: "All Staff"
    };

    const intraStaffOptions = [
        intraAllOption,
        ...intraStaff.map(item => ({
            value: item.staff_id,
            label: `${item.staff_name} (${item.staff_code})`,
            staff_name: item.staff_name,
            staff_code: item.staff_code
        }))
    ];
    // const CheckboxOption = (props) => (
    //     <components.Option {...props}>
    //         <input
    //             type="checkbox"
    //             checked={props.isSelected}
    //             onChange={() => null}
    //             style={{ marginRight: "8px" }}
    //         />
    //         <label>{props.label}</label>
    //     </components.Option>
    // );
    const handleIntraStaffChange = (selectedOptions) => {

        if (!selectedOptions) {
            setIntraStaffIds([]);
            return;
        }

        const isAllSelected = selectedOptions.some(
            option => option.value === "all"
        );

        if (isAllSelected) {

            setIntraStaffIds(
                intraStaff.map(item => ({
                    value: item.staff_id,
                    label: `${item.staff_name} (${item.staff_code})`,
                    staff_name: item.staff_name,
                    staff_code: item.staff_code
                }))
            );

        } else {

            setIntraStaffIds(selectedOptions);

        }
    };
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <ToastContainer />
            <style>{` .calendar-wrapper {
                    background: #ffffff;
                border-radius: 18px;
                overflow: hidden;
                border: 1px solid #dde7e1;
                box-shadow: 0 4px 20px rgba(0,0,0,0.05);
                }

                .month-header {
                    background: #f8faf8;
                border-bottom: 1px solid #e5e7eb;
                padding: 18px;
                text-align: center;
                }

                .month-header h4 {
                    color: #2f3a45;
                font-weight: 700;
                margin: 0;
                letter-spacing: .5px;
                }

                .calendar-table {
                    margin - bottom: 0 !important;
                }
                .calendar-table thead .employee-column {
                 z-index: 5;
                 }
                .calendar-table thead th {
                    background: #f1f8f4;
                color: #2f3a45;
                border: 1px solid #dde7e1;
                font-size: 14px;
                font-weight: 600;
                padding: 15px;
                }
                .employee-column {
                background: #f8faf8 !important;
                position: sticky;
                left: 0;
                z-index: 2
                font-weight: 600;
                color: #2f3a45;
                }
                .calendar-table tbody tr:nth-child(even) {
                    background: #fcfcfc;
                }
                .calendar-table tbody tr:hover {
                    background: #f9fcfa;
                }
                .calendar-table td {
                    border: 1px solid #edf2ef;
                height: 70px;
                vertical-align: middle;
                }
                .shift-dot {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #8B5CF6;
                margin: 0 auto;
                cursor: pointer;
                box-shadow: 0 0 0 4px rgba(102, 187, 166, 0.2);
                }
                .shift-dot:hover {
                transform: scale(1.15);
                }
                .week-title {
                color: #4caf50;
                font-weight: 700;
                }
                .assignment-panel {
                border - radius: 16px;
                border: 1px solid #dde7e1;
                box-shadow: 0 4px 15px rgba(0,0,0,.04);
                }
                .assignment-panel .card-header {
                background: #f8faf8;
                border-bottom: 1px solid #dde7e1;
                }
                .custom-tooltip .tooltip-inner {
                background: white;
                color: #2f3a45;
                border: 1px solid #dde7e1;
                border-radius: 12px;
                padding: 12px;
                text-align: left;
                box-shadow: 0 6px 20px rgba(0,0,0,.12);
                }
                .custom-tooltip .tooltip-arrow::before {
                border - top - color: white !important;
                }
                .shift-label {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 6px;
                }
                .shift-item {
                display: flex;
                align-items: center;
                gap: 6px;
                }
                .dot-daily {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #8B5CF6; /* Purple */
                }
                .dot-inter {
                width: 10px;
                height: 10px;
                display: inline-block;
                background-color: #F97316;
                transform: rotate(45deg);
                }
                .dot-intra {
                width: 0;
                height: 0;
                display: inline-block;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-bottom: 12px solid #15803D; /* Dark green triangle */
                }
                .daily-text {
                color: #2563EB;
                font-size: 7px;
                }
                .inter-text {
                color: #F97316;
                font-size: 7px;
                }
                .intra-text {
                color: #15803D;
                font-size: 7px;
                }
.dot-daily-continuous {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #DC2626; /* Red */
}
.daily-text-continuous {
    color: #DC2626; /* Red */
    font-size: 7px;
    font-weight: 600;
}
            `}

            </style>
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <section id="main-content">
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="card-title">Shift Assignment</h6>
                                </div>

                                <div className="card-body">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-lg-4 col-md-6">
                                            <label className="form-label">Branch</label>

                                            <Select
                                                options={branch.map((item) => ({
                                                    value: item.branch_id,
                                                    label: item.branch_name
                                                }))}

                                                value={
                                                    branchId
                                                        ? {
                                                            value: branchId,
                                                            label: selectedBranchName
                                                        }
                                                        : null
                                                }

                                                onChange={(selectedOption) => {

                                                    setBranchId(
                                                        selectedOption
                                                            ? selectedOption.value
                                                            : ""
                                                    );

                                                    setSelectedBranchName(
                                                        selectedOption
                                                            ? selectedOption.label
                                                            : ""
                                                    );

                                                    console.log(
                                                        "Branch ID:",
                                                        selectedOption?.value
                                                    );

                                                    console.log(
                                                        "Branch Name:",
                                                        selectedOption?.label
                                                    );
                                                }}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 999
                                                    })
                                                }}
                                                placeholder="Search Branch..."
                                                isSearchable
                                            />

                                        </div>

                                    </div>
                                    <div className="shift-label">
                                        <div className="shift-item">
                                            <span className="dot-daily"></span>
                                            <span>Scheduled Shift </span>
                                        </div>

                                        <div className="shift-item">
                                            <span className="dot-inter"></span>
                                            <span>Inter Shift </span>
                                        </div>

                                        <div className="shift-item">
                                            <span className="dot-intra"></span>
                                            <span>Intra Shift</span>
                                        </div>
                                        <div className="shift-item">
                                            <span className="dot-daily-continuous"></span>
                                            <span>Generic Shift</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card mt-4">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0 week-title">
                                        <Icon.Calendar3
                                            size={18}
                                            style={{ marginRight: 8 }}
                                        />
                                        Weekly Shift Calendar
                                    </h6>

                                    <button
                                        className="btn btn-success"
                                        onClick={() =>
                                            setShowAssignPanel(!showAssignPanel)
                                        }
                                    >
                                        <Icon.CalendarCheck />
                                        {" "}Assign Shift
                                    </button>
                                </div>
                                <div className="row">

                                    {/* Calendar Left Side */}
                                    <div className={showAssignPanel ? "col-lg-9" : "col-lg-12"}>

                                        <div
                                            className="table-responsive"
                                            style={{ overflowX: "auto" }}
                                        >
                                            {/* Month Heading */}

                                            <div className="month-header">
                                                <h4>
                                                    {new Date().toLocaleDateString("en-US", {
                                                        month: "long",
                                                        year: "numeric",
                                                    })}
                                                </h4>
                                            </div>

                                            {/* Calendar Table */}
                                            <div className="calendar-wrapper">
                                                <table className="table calendar-table align-middle text-center">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                className="employee-column"
                                                                style={{ minWidth: "220px" }}
                                                            >
                                                                Employee Name
                                                            </th>

                                                            {weekDates.map((date, index) => (
                                                                <th key={index}>
                                                                    <div
                                                                        style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: "700"
                                                                        }}
                                                                    >
                                                                        {date.day}
                                                                    </div>

                                                                    <small
                                                                        style={{
                                                                            color: "#6B7280"
                                                                        }}
                                                                    >
                                                                        {date.weekDay}
                                                                    </small>
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {employees.map((emp) => (
                                                            <tr key={emp.staff_id}>
                                                                {/* <td className="employee-column">
                                                                    {emp.staff_name}
                                                                </td>*/}
                                                                <td className="employee-column">
                                                                    {emp.staff_name?.toUpperCase()}
                                                                </td>
                                                                {weekDates.map((date, idx) => {

                                                                    const assigned = hasShiftAssignment(
                                                                        emp.staff_id,
                                                                        date.fullDate
                                                                    );

                                                                    const shiftInfo = getShiftDetails(
                                                                        emp.staff_id,
                                                                        date.fullDate
                                                                    );

                                                                    const interAssigned =
                                                                        hasInterShiftAssignment(
                                                                            emp.staff_id,
                                                                            date.fullDate
                                                                        );

                                                                    const interShiftInfo =
                                                                        getInterShiftDetails(
                                                                            emp.staff_id,
                                                                            date.fullDate
                                                                        );
                                                                    const intraAssigned =
                                                                        hasIntraShiftAssignment(
                                                                            emp.staff_id,
                                                                            date.fullDate
                                                                        );

                                                                    const intraShiftInfo =
                                                                        getIntraShiftDetails(
                                                                            emp.staff_id,
                                                                            date.fullDate
                                                                        );
                                                                    return (
                                                                        <td key={idx}>

                                                                            {/* Daily Shift Blue Dot */}
                                                                            {assigned && shiftInfo && (

                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={
                                                                                        <Tooltip
                                                                                            id={`daily-${emp.staff_id}-${idx}`}
                                                                                            className="custom-tooltip"
                                                                                        >
                                                                                            <div style={{ textAlign: "left" }}>

                                                                                                <div>
                                                                                                    <strong>Branch :</strong>{" "}
                                                                                                    {shiftInfo.assign_branchname}
                                                                                                </div>


                                                                                                <div>
                                                                                                    <strong>Shift :</strong>{" "}
                                                                                                    {shiftInfo.asign_shiftname}
                                                                                                </div>

                                                                                                <div style={{ marginLeft: "42px", fontSize: "12px", color: "#6c757d" }}>
                                                                                                    [{formatTime(shiftInfo.type_from)} - {formatTime(shiftInfo.type_to)}]
                                                                                                </div>
                                                                                                {/* <div>
                                                                                                    <strong>Shift :</strong> {shiftInfo.asign_shiftname}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>Time :</strong>{" "}
                                                                                                    {formatTime(shiftInfo.type_from)} - {formatTime(shiftInfo.type_to)}
                                                                                                </div>*/}
                                                                                                <div>
                                                                                                    <strong>From :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        shiftInfo.assing_fromdate
                                                                                                    ).toLocaleDateString("en-GB")}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>To :</strong>{" "}
                                                                                                    {
                                                                                                        shiftInfo.assign_todate
                                                                                                            ? new Date(shiftInfo.assign_todate).toLocaleDateString("en-GB")
                                                                                                            : "Ongoing"
                                                                                                    }
                                                                                                    {/* <strong>To :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        shiftInfo.assign_todate ||
                                                                                                        shiftInfo.assing_fromdate
                                                                                                    ).toLocaleDateString("en-GB")}*/}
                                                                                                </div>

                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    }
                                                                                >
                                                                                    {/* <div className="dot-daily" />*/}
                                                                                    <div className="shift-indicator">
                                                                                        {/*<div className="dot-daily"></div>*/}
                                                                                        <div
                                                                                            className={
                                                                                                isContinuousShift(shiftInfo)
                                                                                                    ? "dot-daily-continuous"
                                                                                                    : "dot-daily"
                                                                                            }
                                                                                        />
                                                                                        <div
                                                                                            className={
                                                                                                isContinuousShift(shiftInfo)
                                                                                                    ? "shift-text daily-text-continuous"
                                                                                                    : "shift-text daily-text"
                                                                                            }
                                                                                        >
                                                                                            {shiftInfo.asign_shiftname}
                                                                                        </div>
                                                                                        {/*  <div className="shift-text daily-text">
                                                                                            {shiftInfo.asign_shiftname}
                                                                                        </div>*/}
                                                                                    </div>
                                                                                </OverlayTrigger>

                                                                            )}

                                                                            {/* Inter Shift Orange Dot */}
                                                                            {interAssigned && interShiftInfo && (

                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={
                                                                                        <Tooltip
                                                                                            id={`inter-${emp.staff_id}-${idx}`}
                                                                                            className="custom-tooltip"
                                                                                        >
                                                                                            <div style={{ textAlign: "left" }}>

                                                                                                <div>
                                                                                                    <strong>Home Branch :</strong>{" "}
                                                                                                    {interShiftInfo.branch_name}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>Shift Branch :</strong>{" "}
                                                                                                    {interShiftInfo.shiftbranch_name}
                                                                                                </div>

                                                                                                {/* <div>
                                                                                                    <strong>Shift :</strong>{" "}
                                                                                                    {interShiftInfo.shifttype_name}
                                                                                                </div>*/}
                                                                                                <div>
                                                                                                    <strong>Shift :</strong>{" "}
                                                                                                    {interShiftInfo.shifttype_name}
                                                                                                </div>

                                                                                                <div
                                                                                                    style={{
                                                                                                        marginLeft: "42px",
                                                                                                        fontSize: "12px",
                                                                                                        color: "#6c757d",
                                                                                                    }}
                                                                                                >
                                                                                                    [{formatTime(interShiftInfo.type_from)} - {formatTime(interShiftInfo.type_to)}]
                                                                                                </div>
                                                                                                <div>
                                                                                                    <strong>From :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        interShiftInfo.shift_from
                                                                                                    ).toLocaleDateString("en-GB")}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>To :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        interShiftInfo.shift_to
                                                                                                    ).toLocaleDateString("en-GB")}
                                                                                                </div>

                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    }
                                                                                >

                                                                                    <div className="shift-indicator">
                                                                                        <div className="dot-inter"></div>
                                                                                        <div className="shift-text inter-text">
                                                                                            {interShiftInfo.shifttype_name}
                                                                                        </div>
                                                                                    </div>
                                                                                </OverlayTrigger>

                                                                            )}

                                                                            {/* Intra Shift Green Dot */}
                                                                            {intraAssigned && intraShiftInfo && (

                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={
                                                                                        <Tooltip
                                                                                            id={`intra-${emp.staff_id}-${idx}`}
                                                                                            className="custom-tooltip"
                                                                                        >
                                                                                            <div style={{ textAlign: "left" }}>

                                                                                                <div>
                                                                                                    <strong>Branch :</strong>{" "}
                                                                                                    {intraShiftInfo.branch_name}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>Shift :</strong>{" "}
                                                                                                    {intraShiftInfo.shifttype_name}
                                                                                                </div>
                                                                                                <div
                                                                                                    style={{
                                                                                                        marginLeft: "42px",
                                                                                                        fontSize: "12px",
                                                                                                        color: "#6c757d",
                                                                                                    }}
                                                                                                >
                                                                                                    [{formatTime(intraShiftInfo.type_from)} - {formatTime(intraShiftInfo.type_to)}]
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>From :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        intraShiftInfo.shift_from
                                                                                                    ).toLocaleDateString("en-GB")}
                                                                                                </div>

                                                                                                <div>
                                                                                                    <strong>To :</strong>{" "}
                                                                                                    {new Date(
                                                                                                        intraShiftInfo.shift_to
                                                                                                    ).toLocaleDateString("en-GB")}
                                                                                                </div>

                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    }
                                                                                >

                                                                                    <div className="shift-indicator">
                                                                                        <div className="dot-intra"></div>
                                                                                        <div className="shift-text intra-text">
                                                                                            {intraShiftInfo.shifttype_name}
                                                                                        </div>
                                                                                    </div>
                                                                                </OverlayTrigger>

                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Side Panel */}
                                    {showAssignPanel && (
                                        <div className="col-lg-3">
                                            <div className="card assignment-panel">
                                                <div className="card-header">
                                                    <h6
                                                        className="mb-0"
                                                        style={{ color: "#198754" }}
                                                    >
                                                        Shift Assignment
                                                    </h6>
                                                </div>

                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={selectedBranchName}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div
                                                        className="d-flex justify-content-between align-items-center mb-3"
                                                        style={{
                                                            borderBottom: "1px solid #dee2e6",
                                                            paddingBottom: "5px",
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            onClick={() => setActiveTab("daily")}
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                paddingBottom: "8px",
                                                                color:
                                                                    activeTab === "daily"
                                                                        ? "#198754"
                                                                        : "#6c757d",
                                                                borderBottom:
                                                                    activeTab === "daily"
                                                                        ? "2px solid #198754"
                                                                        : "2px solid transparent",
                                                                fontWeight:
                                                                    activeTab === "daily"
                                                                        ? "600"
                                                                        : "400",
                                                            }}
                                                        >
                                                            Daily
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => setActiveTab("inter")}
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                paddingBottom: "8px",
                                                                color:
                                                                    activeTab === "inter"
                                                                        ? "#198754"
                                                                        : "#6c757d",
                                                                borderBottom:
                                                                    activeTab === "inter"
                                                                        ? "2px solid #198754"
                                                                        : "2px solid transparent",
                                                                fontWeight:
                                                                    activeTab === "inter"
                                                                        ? "600"
                                                                        : "400",
                                                            }}
                                                        >
                                                            Inter
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => setActiveTab("intra")}
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                cursor: "pointer",
                                                                paddingBottom: "8px",
                                                                color:
                                                                    activeTab === "intra"
                                                                        ? "#198754"
                                                                        : "#6c757d",
                                                                borderBottom:
                                                                    activeTab === "intra"
                                                                        ? "2px solid #198754"
                                                                        : "2px solid transparent",
                                                                fontWeight:
                                                                    activeTab === "intra"
                                                                        ? "600"
                                                                        : "400",
                                                            }}
                                                        >
                                                            Intra
                                                        </button>
                                                    </div>
                                                    {activeTab === "daily" && (
                                                        <div>
                                                            <div className="fw-bold" style={{ color: "#198754" }}>
                                                                SCHEDULED SHIFT ASSIGNMENT
                                                            </div>

                                                            <div className="mb-3">
                                                                <label className="form-label">Department</label>

                                                                <Select
                                                                    options={dept.map((item) => ({
                                                                        value: item.dept_id,
                                                                        label: item.dept_name,
                                                                    }))}
                                                                    value={
                                                                        deptId
                                                                            ? {
                                                                                value: deptId,
                                                                                label: dept.find(d => d.dept_id === deptId)?.dept_name || ""
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) => {
                                                                        setDeptId(selectedOption.value);
                                                                        //setDept(selectedOption.label);
                                                                    }}


                                                                    placeholder="Select Department"
                                                                    isSearchable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Staff Name</label>

                                                                <Select
                                                                    isMulti
                                                                    closeMenuOnSelect={false}
                                                                    hideSelectedOptions={false}
                                                                    options={staffOptions}
                                                                    components={{ Option }}
                                                                    value={staffids}
                                                                    onChange={handleStaffChange}
                                                                />
                                                            </div>
                                                            {/*<div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>
                                                                <Select
                                                                    isMulti
                                                                    options={staff.map(item => ({
                                                                        value: item.staff_id,
                                                                        label: `${item.staff_name} (${item.staff_code})`,
                                                                        staff_name: item.staff_name,
                                                                        staff_code: item.staff_code
                                                                    }))}
                                                                    value={staffids}
                                                                    onChange={(selectedOptions) =>
                                                                        setStaffids(selectedOptions || [])
                                                                    }
                                                                />

                                                            </div>*/}

                                                            {/* <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Code
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        staffids
                                                                            .map(sel =>
                                                                                staff.find(
                                                                                    item => item.staff_id.toString() === sel.value.toString()
                                                                                )?.staff_code
                                                                            )
                                                                            .filter(Boolean)
                                                                            .join(", ")
                                                                    }
                                                                    readOnly
                                                                />
                                                            </div>*/}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Code
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        staffids
                                                                            .map(sel => sel.staff_code)
                                                                            .filter(Boolean)
                                                                            .join(", ")
                                                                    }
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Shift Type</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={shiftTypeId}
                                                                    onChange={(e) => setShiftTypeId(e.target.value)}
                                                                >
                                                                    <option value="">Select Shift Type</option>
                                                                    {shifttype.map((item) => (
                                                                        <option key={item.type_id} value={item.type_id}>
                                                                            {item.type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {/* <div className="mb-3">
                                                                <label className="form-label">Effective Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={effectiveDate}
                                                                    onChange={(e) => setEffectiveDate(e.target.value)}
                                                                    min={minDate}
                                                                /></div>*/}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Effective Date Range
                                                                </label>

                                                                <DatePicker
                                                                    selectsRange
                                                                    startDate={startDate}
                                                                    endDate={endDate}
                                                                    onChange={(update) => setDateRange(update)}
                                                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                    monthsShown={2}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select Date Range"
                                                                    isClearable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="applicableWeek"
                                                                        checked={isApplicableWeek}
                                                                        onChange={(e) =>
                                                                            setIsApplicableWeek(e.target.checked)
                                                                        }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="applicableWeek"
                                                                    >
                                                                        Applicable for One Week
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <button
                                                                className="btn btn-success w-100"
                                                                onClick={saveShiftAssignment}
                                                            >
                                                                Save Daily Assignment
                                                            </button>
                                                        </div>

                                                    )}
                                                    {activeTab === "inter" && (
                                                        <div>
                                                            <div className="fw-bold" style={{ color: "#198754" }}>
                                                                INTER SHIFT ASSIGNMENT
                                                            </div>
                                                            <div className="mb-3">
                                                                <label>Department</label>

                                                                <Select
                                                                    options={dept.map((item) => ({
                                                                        value: item.dept_id,
                                                                        label: item.dept_name,
                                                                    }))}

                                                                    value={
                                                                        interDeptId
                                                                            ? {
                                                                                value: interDeptId,
                                                                                label:
                                                                                    dept.find(
                                                                                        (item) =>
                                                                                            item.dept_id.toString() ===
                                                                                            interDeptId.toString()
                                                                                    )?.dept_name || "",
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) => {

                                                                        setInterDeptId(
                                                                            selectedOption
                                                                                ? selectedOption.value
                                                                                : ""
                                                                        );

                                                                        setInterStaffId("");
                                                                    }}

                                                                    placeholder="Select Department"
                                                                    isSearchable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>

                                                                <Select
                                                                    isMulti
                                                                    closeMenuOnSelect={false}
                                                                    hideSelectedOptions={false}
                                                                    options={interStaffOptions}
                                                                    components={{ Option: CheckboxOption }}
                                                                    value={interStaffIds}
                                                                    onChange={handleInterStaffChange}
                                                                />
                                                            </div>
                                                            {/*  <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>
                                                                <Select
                                                                    isMulti
                                                                    options={interStaff.map(item => ({
                                                                        value: item.staff_id,
                                                                        label: `${item.staff_name} (${item.staff_code})`,
                                                                        staff_name: item.staff_name,
                                                                        staff_code: item.staff_code
                                                                    }))}
                                                                    value={interStaffIds}
                                                                    onChange={(selectedOptions) =>
                                                                        setInterStaffIds(selectedOptions || [])
                                                                    }
                                                                />

                                                            </div>*/}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={
                                                                    interStaffIds
                                                                        .map(item => item.staff_code)
                                                                        .filter(Boolean)
                                                                        .join(", ")
                                                                }
                                                                readOnly
                                                            />
                                                            {/*  <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Code
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        interStaffIds
                                                                            .map(item => item.staff_code)
                                                                            .filter(Boolean)
                                                                            .join(", ")
                                                                    }
                                                                    readOnly
                                                                />
                                                            </div>*/}
                                                            <div>
                                                                <label className="form-label">Inter Branch</label>
                                                                <Select
                                                                    options={branches.map((item) => ({
                                                                        value: item.branch_id,
                                                                        label: item.branch_name
                                                                    }))}

                                                                    value={interBranchnew}

                                                                    onChange={(selectedOption) => {
                                                                        setInterBranchnew(selectedOption);
                                                                    }}

                                                                    placeholder="Select Inter Branch..."
                                                                    isSearchable
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="form-label">Shift Type</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={interShiftTypeId}
                                                                    onChange={(e) => setInterShiftTypeId(e.target.value)}
                                                                >
                                                                    <option value="">Select Shift Type</option>

                                                                    {shifttype.map((item) => (
                                                                        <option key={item.type_id} value={item.type_id}>
                                                                            {item.type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {/*  <div className="mb-3">
                                                                <label className="form-label">Effective Date</label>

                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={interEffectiveDate}
                                                                    min={minDate}
                                                                    onChange={(e) => setInterEffectiveDate(e.target.value)}
                                                                />
                                                            </div>*/}
                                                            <div className="mb-3">
                                                                <label className="form-label">Effective Date</label>
                                                                {/* <DatePicker
                                                                    selectsRange
                                                                    startDate={interFromDate}
                                                                    endDate={interToDate}
                                                                    onChange={(update) => setInterDateRange(update)}
                                                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                    monthsShown={2}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select Date Range"
                                                                    isClearable
                                                                />*/}
                                                                <DatePicker
                                                                    selectsRange
                                                                    startDate={interFromDate}
                                                                    endDate={interToDate}
                                                                    onChange={handleDateRangeChange}
                                                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                    monthsShown={2}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select Date Range"
                                                                    isClearable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="interApplicableWeek"
                                                                        checked={isInterApplicableWeek}
                                                                        onChange={(e) =>
                                                                            setIsInterApplicableWeek(e.target.checked)
                                                                        }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="interApplicableWeek"
                                                                    >
                                                                        Applicable for One Week
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <button
                                                                className="btn btn-success w-100"
                                                                onClick={saveInterAssignment}
                                                            >
                                                                Save Inter Assignment
                                                            </button>
                                                        </div>
                                                    )}
                                                    {activeTab === "intra" && (
                                                        <div>
                                                            <div className="fw-bold" style={{ color: "#198754" }}>
                                                                INTRA SHIFT ASSIGNMENT
                                                            </div>
                                                            <div className="mb-3">
                                                                <label>Department</label>

                                                                <Select
                                                                    options={dept.map((item) => ({
                                                                        value: item.dept_id,
                                                                        label: item.dept_name,
                                                                    }))}

                                                                    value={
                                                                        intraDeptId
                                                                            ? {
                                                                                value: intraDeptId,
                                                                                label:
                                                                                    dept.find(
                                                                                        (item) =>
                                                                                            item.dept_id.toString() ===
                                                                                            intraDeptId.toString()
                                                                                    )?.dept_name || "",
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) => {

                                                                        setIntraDeptId(
                                                                            selectedOption
                                                                                ? selectedOption.value
                                                                                : ""
                                                                        );

                                                                        setIntraStaffId("");
                                                                    }}

                                                                    placeholder="Select Department"
                                                                    isSearchable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>

                                                                <Select
                                                                    isMulti
                                                                    isSearchable
                                                                    closeMenuOnSelect={false}
                                                                    hideSelectedOptions={false}
                                                                    options={intraStaffOptions}
                                                                    components={{ Option: CheckboxOption }}
                                                                    value={intraStaffIds}
                                                                    onChange={handleIntraStaffChange}
                                                                    placeholder="Search and Select Staff(s)"
                                                                />
                                                            </div>
                                                            {/*   <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>

                                                                <Select
                                                                    isMulti
                                                                    isSearchable
                                                                    closeMenuOnSelect={false}
                                                                    options={intraStaff.map((item) => ({
                                                                        value: item.staff_id,
                                                                        label: `${item.staff_name} (${item.staff_code})`,
                                                                        staff_name: item.staff_name,
                                                                        staff_code: item.staff_code
                                                                    }))}
                                                                    value={intraStaffIds}
                                                                    onChange={(selectedOptions) =>
                                                                        setIntraStaffIds(selectedOptions || [])
                                                                    }
                                                                    placeholder="Search and Select Staff(s)"
                                                                />
                                                            </div>*/}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Code
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        intraStaffIds
                                                                            .map(item => item.staff_code)
                                                                            .filter(Boolean)
                                                                            .join(", ")
                                                                    }
                                                                    readOnly
                                                                />
                                                            </div>
                                                            {/*<div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Name
                                                                </label>

                                                                <Select
                                                                    options={intraStaff.map((item) => ({
                                                                        value: item.staff_id,
                                                                        label: `${item.staff_name} (${item.staff_code})`,
                                                                    }))}

                                                                    value={
                                                                        intraStaffId
                                                                            ? {
                                                                                value: intraStaffId,
                                                                                label:
                                                                                    intraStaff.find(
                                                                                        (item) =>
                                                                                            item.staff_id.toString() ===
                                                                                            intraStaffId.toString()
                                                                                    )
                                                                                        ? `${intraStaff.find(
                                                                                            (item) =>
                                                                                                item.staff_id.toString() ===
                                                                                                intraStaffId.toString()
                                                                                        ).staff_name} (${intraStaff.find(
                                                                                            (item) =>
                                                                                                item.staff_id.toString() ===
                                                                                                intraStaffId.toString()
                                                                                        ).staff_code})`
                                                                                        : "",
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) =>
                                                                        setIntraStaffId(
                                                                            selectedOption
                                                                                ? selectedOption.value
                                                                                : ""
                                                                        )
                                                                    }

                                                                    placeholder="Select Staff"
                                                                    isSearchable
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Staff Code
                                                                </label>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        intraStaff.find(
                                                                            (item) =>
                                                                                item.staff_id.toString() ===
                                                                                intraStaffId.toString()
                                                                        )?.staff_code || ""
                                                                    }
                                                                    readOnly
                                                                />
                                                            </div>*/}
                                                            <div className="mb-3">
                                                                <label className="form-label">
                                                                    Shift Type
                                                                </label>
                                                                <select
                                                                    className="form-control"
                                                                    value={intraShiftTypeId}
                                                                    onChange={(e) => setintraShiftTypeId(e.target.value)}
                                                                >
                                                                    <option value="">Select Shift Type</option>

                                                                    {shifttype.map((item) => (
                                                                        <option key={item.type_id} value={item.type_id}>
                                                                            {item.type_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Effective Date</label>
                                                                {/* <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={intraEffectiveDate}
                                                                    min={minDate}
                                                                    onChange={(e) => setIntraEffectiveDate(e.target.value)}
                                                                />*/}
                                                                <DatePicker
                                                                    selectsRange
                                                                    startDate={intraFromDate}
                                                                    endDate={intraToDate}
                                                                    onChange={handleIntraDateRangeChange}
                                                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                    monthsShown={2}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select Date Range"
                                                                    isClearable
                                                                />
                                                                {/* <DatePicker
                                                                    selectsRange
                                                                    startDate={intraFromDate}
                                                                    endDate={intraToDate}
                                                                    onChange={(update) => setIntraDateRange(update)}
                                                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                    monthsShown={2}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select Date Range"
                                                                    isClearable
                                                                />*/}
                                                            </div>
                                                            <div className="mb-3">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="intraApplicableWeek"
                                                                        checked={isIntraApplicableWeek}
                                                                        onChange={(e) =>
                                                                            setIsIntraApplicableWeek(e.target.checked)
                                                                        }
                                                                    />

                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="intraApplicableWeek"
                                                                    >
                                                                        Applicable for One Week
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <button
                                                                className="btn btn-success w-100"
                                                                onClick={saveIntraAssignment}
                                                            >
                                                                Save Intra Assignment
                                                            </button>

                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Shiftassign;